import React from 'react';

import LoadingButton from '../../../components/LoadingButton';
import Modal from '../../../components/Modal';
import { parseApiError } from '../../../utils/parseApiError';
import useNotify from '../../../hooks/useNotify';
import { sendEmailVerification } from '../../../api/verification';

const EmailVerification = ({ onClose }) => {
	const [errors, setErrors] = React.useState<APIError>();
	const [sending, setSending] = React.useState(false);
	const notify = useNotify();

	const sendVerify = () => {
		setErrors(undefined);
		setSending(true);
		sendEmailVerification()
			.then(() => {
				notify({
					type: 'success',
					title: 'Success',
					message: 'Please check your email for further instructions.',
					timeout: 5000,
				});
				onClose();
			})
			.catch((error) => {
				setErrors(error.errors);
			})
			.finally(() => {
				setSending(false);
			});
	};

	return (
		<Modal onClose={onClose} bg wrapperClassName="_max-w-md _mx-2 md:_mx-auto">
			<h3
				slot="header"
				className="_py-2 _text-2xl _font-extrabold _text-center _text-gray-700
      _uppercase"
			>
				EMAIL CONFIRMATION
			</h3>
			<div className="_flex _flex-col _justify-center _text-center _mt-4">
				<div>Your email address is required to be verified. Please click the button to send a verification email.</div>
				<LoadingButton type="button" onClick={sendVerify} loading={sending} className="_mb-2 _mt-4 _btn _btn-warning">
					Send Verification Email
				</LoadingButton>
				<button className="_mb-2 _btn _btn-black" onClick={onClose}>
					Cancel
				</button>
				{errors && errors.error && <div className="_mb-3 _text-center form-error">{parseApiError(errors)}</div>}
			</div>
		</Modal>
	);
};

export default EmailVerification;
